import { MessageDescriptor, PrimitiveType } from 'react-intl';

export enum NotificationStatus {
  IDLE = 'IDLE',
  RENDERED = 'RENDERED',
  FADING = 'FADING',
}

export enum NotificationVariant {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export interface NotificationContent {
  type: NotificationVariant;
  message: MessageDescriptor;
  value?: Record<string, PrimitiveType | React.ReactNode>;
}

export interface NotificationInfo {
  notification: NotificationContent;
  timerId: number | NodeJS.Timeout;
  notificationStatus: NotificationStatus;
}

export enum NotificationDuration {
  RENDERED = 5,
  FADING = 0.2,
}
